import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Badge, Menu, MenuItem } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

function MobileBottomBar({ items, onMenuClick, unreadMessagesCount = 0 }) {
  const BOTTOM_BAR_HEIGHT = 64;
  const MENU_GAP = 8;
  const navigate = useNavigate();
  const location = useLocation();
  const [sectionAnchorPosition, setSectionAnchorPosition] = useState(null);
  const [sectionMenuLeft, setSectionMenuLeft] = useState(null);
  const [sectionOptions, setSectionOptions] = useState([]);

  const handleSectionMenuClose = () => {
    setSectionAnchorPosition(null);
    setSectionMenuLeft(null);
    setSectionOptions([]);
  };

  const handleSectionOptionClick = (path) => {
    navigate(path);
    handleSectionMenuClose();
  };

  const handleItemClick = (event, item) => {
    if (item.isMenuTrigger && onMenuClick) {
      onMenuClick();
      return;
    }
    if (item.children && item.children.length > 0) {
      const iconRect = event.currentTarget.getBoundingClientRect();
      const left = Math.round(iconRect.left + iconRect.width / 2);
      setSectionAnchorPosition({ top: 0, left: 0 });
      setSectionMenuLeft(left);
      setSectionOptions(item.children);
      return;
    }
    if (item.path) {
      navigate(item.path);
    }
  };

  const checkActive = (item) => {
    if (item.children && item.children.length > 0) {
      return item.children.some((child) => location.pathname.startsWith(child.path));
    }
    if (!item.path) return false;
    if (item.path === '/dashboard' || item.path === '/supplier/dashboard') {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        px: 1,
        py: 1,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        minHeight: 64,
      }}
    >
      {items.map((item) => {
        const active = checkActive(item);
        const isCenter = item.isCenter === true;

        return (
          <Tooltip key={item.id} title={item.label} placement="top">
            <IconButton
              onClick={(event) => handleItemClick(event, item)}
              sx={{
                color: isCenter ? 'inherit' : (active ? 'text.primary' : 'text.secondary'),
                ...(isCenter && {
                  backgroundColor: active ? '#000000' : '#ffffff',
                  borderRadius: '12px',
                  width: 54,
                  height: 54,
                  border: '1px solid #ebe8e8',
                  boxShadow: '0px 0px 40px #00000014',
                  '&:hover': {
                    backgroundColor: active ? '#1a1a1a' : '#f8f8f8',
                  },
                }),
              }}
            >
              {item.id === 'messages' && unreadMessagesCount > 0 ? (
                <Badge variant="dot" color="error">
                  {item.icon}
                </Badge>
              ) : (
                item.icon
              )}
            </IconButton>
          </Tooltip>
        );
      })}
      <Menu
        anchorReference="anchorPosition"
        anchorPosition={sectionAnchorPosition || undefined}
        open={Boolean(sectionAnchorPosition)}
        onClose={handleSectionMenuClose}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            position: 'fixed',
            top: 'auto !important',
            bottom: `${BOTTOM_BAR_HEIGHT + MENU_GAP}px`,
            right: 'auto !important',
            left: sectionMenuLeft ? `${sectionMenuLeft}px !important` : '50% !important',
            transform: 'translateX(-50%) !important',
            m: 0,
          },
        }}
      >
        {sectionOptions.map((option) => (
          <MenuItem
            key={`${option.title}-${option.path}`}
            onClick={() => handleSectionOptionClick(option.path)}
          >
            {option.title}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default MobileBottomBar;
